import React from 'react';
import styled from 'astroturf/react'
import routes from 'js/core_pre_webpack/routes';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';
import Divider from 'js/design_system/Divider';
import { Heading } from 'js/design_system/Heading';
import _EmptyStateHeader from "ProfileEmptyState-EmptyStateHeader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/ProfileEmptyState.tsx?styleId=EmptyStateHeader";
import _EmptyStateBody from "ProfileEmptyState-EmptyStateBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/ProfileEmptyState.tsx?styleId=EmptyStateBody";
import _styles from "ProfileEmptyState-styles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/ProfileEmptyState.tsx?styleId=styles";


const EmptyStateHeader = /*#__PURE__*/styled(Heading, null, {
  displayName: "EmptyStateHeader",
  styles: _EmptyStateHeader
});

const EmptyStateBody = /*#__PURE__*/styled(Body, null, {
  displayName: "EmptyStateBody",
  styles: _EmptyStateBody
});

const styles = _styles;

const ProfileEmptyState: React.FunctionComponent<{
  isOwner: boolean;
  username: string;
}> = ({ isOwner, username }) => {
  return (
    <>
      {!isOwner && (
        <div>
          <EmptyStateHeader>{username} hasn't posted yet</EmptyStateHeader>
          <EmptyStateBody>
            Once they do, their activity will show up here
          </EmptyStateBody>
        </div>
      )}
      <Divider.s16 />
      <ButtonLink href={routes.home_url()} className={styles.ExploreButton}>
        Explore Conversations ▸
      </ButtonLink>
    </>
  );
};

export default ProfileEmptyState;
